import { HelpCircle } from "@/components/icons";
import { FaqRows, type FaqRowItem } from "@/components/faq/faq-rows";

type FAQSectionProps = {
  items: FaqRowItem[];
  title?: string;
  subtitle?: string;
  isAskable?: boolean;
};

export function FAQSection({
  items,
  title = "Frequently Asked Questions",
  subtitle,
  isAskable,
}: FAQSectionProps) {
  return (
    <div className="bg-card border border-border">
      <div className="flex items-center gap-2 px-4 py-2 bg-muted border-b border-border">
        <HelpCircle className="h-3.5 w-3.5 text-muted-foreground" />
        <span className="text-xs font-medium text-muted-foreground">
          {title}
        </span>
        {subtitle && (
          <>
            <span className="text-muted-foreground">—</span>
            <span className="text-xs text-muted-foreground">{subtitle}</span>
          </>
        )}
      </div>

      <FaqRows items={items} variant="inset" isAskable={isAskable} />
    </div>
  );
}
